import {
    SAVE_LANGUAGE,
    SAVE_LANGUAGE_JSON,
    SAVE_SUPPORTED_LANGUAGES
} from './actions';

export const initialState = {
    language: 'ENGLISH',
    languageJSON: {},
    supportedLanguages: []
};

const languageReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_LANGUAGE:
            return {
                ...state,
                language: action.language
            }
        case SAVE_SUPPORTED_LANGUAGES:
            return {
                ...state,
                supportedLanguages: action.supportedLanguages
            }
        case SAVE_LANGUAGE_JSON:
            return {
                ...state,
                languageJSON: JSON.parse(action.languageJSON)
            }
        default: return state
    }
}

export default languageReducer;